const size = {
  mobile: "500px",
  desktop: "1920px",
};

const theme = {
  mobile: `(max-width: ${size.mobile})`,
  desktop: `(min-width: ${size.desktop})`,
};

export default theme;
